import { render } from "./indexConfigPublicAreaComponent.vue?vue&type=template&id=44e9ca24&scoped=true"
import script from "./indexConfigPublicAreaComponent.vue?vue&type=script&lang=js"
export * from "./indexConfigPublicAreaComponent.vue?vue&type=script&lang=js"

import "./indexConfigPublicAreaComponent.vue?vue&type=style&index=0&id=44e9ca24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e9ca24"]])

export default __exports__